//Please add the language resource
const yardLoadEfficiency = {

  itrYardCode:'ItrYardCode',
  itrYardName:'ItrYardName',
  itrCode: 'ItrCode',
  totalQty: 'TotalQty',
  customerCode: 'TustomerCode',
  consigneeCode:'ConsigneeCode',
  carrierNo:'CarrierNo',
  shipGoodsFlagStr:'ShipGoodsFlagStr',

  truckNo:'TruckNo',
  planExpToTime:'PlanExpToTime',
  inTime: 'InTime',
  outTime:'OutTime',
  loadUseHour:'LoadUseHour',

  msg:{
  }
};
export default yardLoadEfficiency



// WEBPACK FOOTER //
// ./src/page/report/yardLoadEfficiency/lang/yardLoadEfficiency.en.js